import React from "react";
import ellipseBlue from "../../assets/images/ellipse-blue.svg";
import greyCheck from "../../assets/images/grey-checkmark.svg";
import SubscriptionModal from "./SubscriptionModal";

const AboutSubscription = ({
  isSubscribed = false,
  isExpired = false,
  advisorId,
}) => {
  return (
    <div className="p-4 lg:p-6">
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="flex-1 space-y-8">
          <div>
            <h2 className="text-xl lg:text-2xl font-semibold text-[#454545] mb-6">
              Key Highlights
            </h2>
            <ul className="space-y-3 font-normal text-base lg:text-base text-[#222222] list-disc pl-6">
              <li>Daily trading signals</li>
              <li>Independent Trading Strategy</li>
              <li>Real-Time Trade Ideas</li>
              <li>Doubt Solving Sessions</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl lg:text-2xl font-semibold text-[#454545] mb-6">
              Trading Strategy Details
            </h2>
            <ol className="space-y-4 text-base lg:text-base text-[#222222] list-decimal pl-6">
              <li className="leading-relaxed">
                <span className="font-medium">Daily Trading Signals:</span>{" "}
                Receive 5-8 expertly curated trading signals daily. Our focus
                encompasses key market movers such as Nifty, BankNifty,
                FinNifty, and Sensex, ensuring a comprehensive market approach.
              </li>
              <li className="leading-relaxed">
                <span className="font-medium">
                  BTST (Buy Today, Sell Tomorrow) Advantage:
                </span>{" "}
                Beyond intraday, harness the power of BTST calls, optimized for
                short-term trading opportunities.
              </li>
              <li className="leading-relaxed">
                <span className="font-medium">Live Trading Sessions:</span>{" "}
                Engage in interactive sessions, designed to demystify trading
                complexities, clarify doubts, and strengthen your trading
                foundation.
              </li>
              <li className="leading-relaxed">
                <span className="font-medium">Real-Time Trade Ideas:</span> Our
                actionable trade ideas are not just theoretical but rooted in
                real-time market dynamics, ensuring you're always a step ahead.
              </li>
              <li className="leading-relaxed">
                <span className="font-medium">Optimized Risk-Reward:</span>{" "}
                Benefit from signals boasting an impressive hit rate, balanced
                with optimal risk-reward ratios, ensuring your trades align with
                profitability and security.
              </li>
              <li className="leading-relaxed">
                <span className="font-medium">Verified Track Record:</span>{" "}
                Trust, backed by results. Our past performance stands as a
                testament to our expertise, dedication, and analytical prowess.
              </li>
              <li className="leading-relaxed">
                <span className="font-medium">Thriving Trading Community:</span>{" "}
                Join a vibrant community of traders. Engage, learn, and grow in
                an environment that fosters knowledge exchange and mutual
                support. Step into a realm of trading where every signal,
                strategy, and session is designed with your success at its core.
                Together, let's navigate the market's intricacies, transforming
                challenges into opportunities.
              </li>
            </ol>
          </div>
        </div>

        {!isSubscribed && (
          <div className="lg:w-[350px] flex-shrink-0">
            <div className="p-6 bg-[#FFFFFF] rounded-lg border shadow-[0_2px_8px_rgba(0,0,0,0.1)] sticky top-4">
              <h2 className="text-xl lg:text-2xl font-semibold font-inter  text-[#454545] mb-4">
                Start with plan
              </h2>
              <div className="bg-[#C5E6FF] p-6 rounded-lg border border-[#67B8F8]">
                <div className="flex justify-between items-start mb-4">
                  <h4 className="text-lg font-semibold text-[#1569AB]">Free</h4>
                  <img src={ellipseBlue} width={20} alt="" />
                </div>
                <div className="mb-4">
                  <div className="text-2xl font-normal text-[#333] mb-1">
                    ₹ 0
                  </div>
                  <div className="text-sm text-[#000000]">
                    1 month free subscription trial
                  </div>
                </div>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center gap-2">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="18" height="18" rx="4" fill="white" />
                      <path
                        d="M13.5 5.25L7.125 12.75L4.5 9.75"
                        stroke="#B0B0B0"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="text-sm text-[#7F7F7F]">
                      Real-time contact syncing
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="18" height="18" rx="4" fill="white" />
                      <path
                        d="M13.5 5.25L7.125 12.75L4.5 9.75"
                        stroke="#B0B0B0"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="text-sm text-[#7F7F7F]">
                      Automatic data enrichment
                    </span>
                  </div>
                  <div className="flex items-center gap-2 ">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="18" height="18" rx="4" fill="white" />
                      <path
                        d="M13.5 5.25L7.125 12.75L4.5 9.75"
                        stroke="#B0B0B0"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="text-sm text-[#7F7F7F]">
                      Up to 3 seats
                    </span>
                  </div>
                </div>
                {/* <SubscriptionModal
                text={`Get Started !`}
                classname={`w-full px-6 py-2.5 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-colors`}
                advisorId={advisorId}
              /> */}
              </div>
            </div>
          </div>
        )}
      </div>

      {isSubscribed && !isExpired && (
        <div className="mt-8">
          <div className="p-4 bg-green-50 rounded-lg border border-green-200 text-center sticky top-4">
            <h3 className="text-green-600 font-semibold text-lg mb-2">
              You're Following This Advisor
            </h3>
            <p className="text-[#595959] text-sm">
              You have access to all premium features and trading signals.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutSubscription;
